/**
 * SurfaceNewsRail — published items, as a rail of peers.
 *
 * Any surface with an editorial feed: a publisher's patch notes, a brand's
 * announcements, an org's roster news. It takes items, not a Drop.
 *
 * It exists as its own component rather than a bare `SurfaceStrip` call because
 * news has one rule of its own worth keeping in one place: the byline goes in
 * the meta slot and never a summary. A strip card has room for one line, and
 * who published a piece is what distinguishes it from the one beside it —
 * whereas the first line of the body is usually the same words as the title.
 */

import React from "react";
import {SurfaceStrip} from "./SurfaceStrip";

export interface SurfaceNewsItem {
    id: string;
    title: string;
    /** Who published it. */
    author?: string;
    imageUrl?: string;
    /** External, so the card opens a new tab rather than the stage. */
    url?: string;
}

export interface SurfaceNewsRailProps {
    items: readonly SurfaceNewsItem[];
    /** The operator's own label for the section. */
    kicker?: string;
}

export const SurfaceNewsRail: React.FC<SurfaceNewsRailProps> = ({items, kicker}) =>
    <SurfaceStrip
        /* Headlines are prose, not names — see `headline` on SurfaceStrip. */
        headline
        kicker={kicker}
        cards={items.map(n => ({
            id: n.id,
            title: n.title,
            meta: n.author,
            imageUrl: n.imageUrl,
            href: n.url,
        }))}
    />;

export default SurfaceNewsRail;
